
import { useTranslation } from 'react-i18next';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

export default function Bio() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-32 pb-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-3xl md:text-4xl font-light tracking-wider text-gray-800 uppercase mb-8">
              {t('bio')}
            </h1>
          </div>

          <div className="grid md:grid-cols-2 gap-16 items-start">
            {/* Portrait */}
            <div className="order-2 md:order-1">
              <div className="aspect-[3/4] bg-gray-100 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/d565a50581ac57e107e04059a42e1374/5d4d5f594615581585f5b9af652a0c47.jpeg"
                  alt="Pedro Faerstein"
                  className="w-full h-full object-cover object-left"
                />
              </div>
            </div>

            {/* Bio Content */}
            <div className="order-1 md:order-2 space-y-8">
              <div className="space-y-6 text-lg font-light tracking-wide text-gray-700 leading-relaxed">
                <p className="whitespace-pre-line">
                  {t('bioContent')}
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
